<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
  import $ from 'jquery';
  import addClientEvent from "./api/addClientEvent";
  export default {
    name: 'App',
    data() {
      return {
        minHeight:''
      }
    },
    created () {
      //addClientEvent.setStorageParam()
    },
    mounted () {
      setInterval(e => {
        addClientEvent.recordEventInfo(0)
      }, 1000 * 5)
    }
  }

</script>

<style scoped>
  @import "./assets/sass/normal.scss";
 
  #app { 
    /* background-image: linear-gradient(-180deg, #165CEA 0%, #2470FF 100%); */
    min-height: 100vh;
    /* padding:1px;  */
    box-sizing:border-box; 
    background: rgb(24, 95, 237);
    }
</style>



// WEBPACK FOOTER //
// src/App.vue